import Vue from "vue";
import axios from "axios";

export default {
    setBet: async ({ commit, dispatch }, bet) => {
        commit("setBetState", bet);
        delete bet.win;
        delete bet.answer;
        let gameSetId = localStorage.getItem("gameSetId");
        let uid = localStorage.getItem("uid");
        let workspaceId = localStorage.getItem("workspaceId");
        if (gameSetId) {
            Vue.http
                .post(
                    `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/solo-games`,
                    {
                        bet,
                        gameSetId
                    }
                )
                .then(response => {
                    commit("setNowState", response.body.now);
                    let soloGame = response.body.soloGame;
                    dispatch("setSoloGame", soloGame);
                });
        } else {
            let gameSetId;

            try {
                const gameSetGet = await axios.get(
                    `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/game-sets/?userId=${uid}&workspaceId=${workspaceId}`
                );
                // console.log(gameSetGet);
                if (gameSetGet.data.id) {
                    gameSetId = gameSetGet.data.id;
                    dispatch("setGameSetId", gameSetId);
                }
                const soloGameRequest = await axios.post(
                    `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/solo-games`,
                    {
                        bet,
                        gameSetId
                    }
                );
                // console.log(soloGameRequest);
                commit("setNowState", soloGameRequest.data.now);
                dispatch("setSoloGame", soloGameRequest.data.soloGame);
            } catch (error) {
                const gameSetPost = await axios.post(
                    `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/game-sets/`,
                    {
                        userId: uid,
                        workspaceId,
                        "status": "inprogress",
                        "qtMaxSoloGames": 4
                    }
                );
                // console.log(gameSetPost);
                gameSetId = gameSetPost.data.id;
                dispatch("setGameSetId", gameSetId);
                const soloGameRequest = await axios.post(
                    `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/solo-games`,
                    {
                        bet,
                        gameSetId
                    }
                );
                // console.log(soloGameRequest);
                commit("setNowState", soloGameRequest.data.now);
                dispatch("setSoloGame", soloGameRequest.data.soloGame);
            }

            // Vue.http
            //     .get(
            //         `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/game-sets/?userId=${uid}`
            //     )
            //     .then(response => {
            //         console.log(response);
            //         gameSetId = response.data.id;
            //         dispatch("setGameSetId", gameSetId);
            //     })
            //     .catch(error => {
            //         console.log(error);
            //         Vue.http
            //             .post(
            //                 `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/game-sets/`,
            //                 {
            //                     userId: uid,
            //                     workspaceId
            //                 }
            //             )
            //             .then(response => {
            //                 console.log(response);
            //                 gameSetId = response.body.id;
            //                 dispatch("setGameSetId", gameSetId);
            //             });
            //     });
            // Vue.http
            //     .post(
            //         `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/solo-games`,
            //         {
            //             bet,
            //             gameSetId
            //         }
            //     )
            //     .then(response => {
            //         console.log(response);
            //         commit("setNowState", response.body.now);
            //         dispatch("setSoloGame", response.body.soloGame);
            //     })
            //     .catch(error => {
            //         console.error(error);
            //     });

            // // Vue.http.post(`${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/game-sets/`, {
            // //     "userId" : uid,
            // //     workspaceId
            // // }).then(response => {
            // //         let gameSetId = response.body.id
            // //         dispatch('setGameSetId', gameSetId)

            // //    })
        }
    }
};
